import React from "react";
import {FormControl, FormLabel, TextField, Checkbox} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import CountrySelect from "../CountrySelect/CountrySelect";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {withTranslation} from "react-i18next";

const useStyles = makeStyles(theme => {
    return {
        formInput: {
            minWidth: 250,
            marginRight: theme.spacing(1)
        },
        label: {
            paddingTop: theme.spacing(2),
            color: theme.palette.primary
        }
    }
});

const AddDialogPlayer = (props) => {
    const {
        category, params, country, gender, firstName, handlePlayerChange, handlePlayerCheckbox, handleBlur,
        lastName, playerIdx, firstNameError, lastNameError, t
    } = props;
    const classes = useStyles();
    let label = t('registrationForm.dialog.player') + " #" + (playerIdx + 1);
    if (category.eligibility === 'MIXED') {
        label = label + ': ' + t('gender.' + gender);
    }
    const countryChangeHandler = (e) => {
        const fakeEvent = {
            target: {
                value: e
            }
        };
        handlePlayerChange(fakeEvent, playerIdx, 'country');
    };

    const checkboxChangeHandler = (e, playerIdx, param) => {
        handlePlayerCheckbox(e, playerIdx, param);
    }

    const parameterInputs = [];
    if (category.params && category.params.length > 0) {
        category.params.forEach((p, idx) => {
            if (p.granularity === 'PLAYER') {
                const playerParam = params.find(pp => pp.name === p.name);
                const checked = playerParam ? playerParam.boolValue : false;
                parameterInputs.push(<FormControlLabel key={'cb-' + playerIdx + '-' + p.name} value={p.name} control={<Checkbox onChange={(e) => checkboxChangeHandler(e, idx, p)} color="primary" checked={checked} />} label={p.name} labelPlacement="start" />);
            }
        });
    }

    const excludes = ['GB'];
    return (
        <>
            <FormControl fullWidth={true}>
                <FormLabel className={classes.label} >{label}</FormLabel>
            </FormControl>
            <FormControl className={classes.formInput} fullWidth={false} margin="none">
                <TextField
                    autoComplete="off"
                    helperText={t('registrationForm.player.firstName')}
                    margin="normal"
                    value={firstName}
                    error={firstNameError}
                    onChange={(e) => handlePlayerChange(e, playerIdx, 'firstName')}
                    onBlur={(e) => handleBlur(e, playerIdx, 'firstName')}
                />
            </FormControl>
            <FormControl className={classes.formInput} fullWidth={false} margin="none">
                <TextField
                    autoComplete="off"
                    helperText={t('registrationForm.player.lastName')}
                    margin="normal"
                    value={lastName}
                    error={lastNameError}
                    onChange={(e) => handlePlayerChange(e, playerIdx, 'lastName')}
                    onBlur={(e) => handleBlur(e, playerIdx, 'lastName')}
                />
            </FormControl>
            <CountrySelect excludeCountries={excludes} onCountrySelected={countryChangeHandler} country={country} />
            {parameterInputs}
        </>
    );
};

export default withTranslation('messages')(AddDialogPlayer);